import styled from 'styled-components';
import { Button } from 'antd';

import useI18n from '../../common/hooks/useI18n';

type Props = {
  onClick: () => void;
  className?: string;
};

const GalleryButton: React.FC<Props> = ({ onClick, className }) => {
  const i18n = useI18n();

  return (
    <Button className={className} type="ghost" onClick={onClick}>
      {i18n.t('flatDetail.actions.showAllPhotos')}
    </Button>
  );
};

export default styled(GalleryButton)`
  font-weight: 500;
  border-width: 2px;
  color: #fff;

  &:active,
  &:hover,
  &:focus {
    color: #fff;
    border-color: #fff;
  }
`;
